import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Question\UpdateQuestionController::__invoke
* @see app/Http/Controllers/Question/UpdateQuestionController.php
* @route '/api/question/{question}'
*/
const UpdateQuestionController = (args: { question: string | number | { id: string | number } } | [question: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateQuestionController.url(args, options),
    method: 'put',
})

UpdateQuestionController.definition = {
    methods: ["put"],
    url: '/api/question/{question}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Question\UpdateQuestionController::__invoke
* @see app/Http/Controllers/Question/UpdateQuestionController.php
* @route '/api/question/{question}'
*/
UpdateQuestionController.url = (args: { question: string | number | { id: string | number } } | [question: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { question: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { question: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            question: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        question: typeof args.question === 'object'
        ? args.question.id
        : args.question,
    }

    return UpdateQuestionController.definition.url
            .replace('{question}', parsedArgs.question.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Question\UpdateQuestionController::__invoke
* @see app/Http/Controllers/Question/UpdateQuestionController.php
* @route '/api/question/{question}'
*/
UpdateQuestionController.put = (args: { question: string | number | { id: string | number } } | [question: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateQuestionController.url(args, options),
    method: 'put',
})

export default UpdateQuestionController